<template>
  <div class="clientes-container">
    <div class="container">
      <div class="logo-container">
        <img src="@/assets/img/logo.png" alt="Asaas Logo" class="logo">
      </div>
      
      <h1 class="title">Migrar Clientes</h1>
      
      <div class="upload-container">
        <input 
          type="file" 
          id="file-upload" 
          accept=".xlsx" 
          @change="handleFileUpload"
          class="file-input"
          :disabled="loading"
        />
        <label for="file-upload" class="file-label">
          <span class="placeholder">{{ fileName || 'importar planilha excel' }}</span>
          <button 
            class="upload-button" 
            @click="uploadFile"
            :disabled="!file || loading"
          >
            <span v-if="!loading">Enviar Planilha</span>
            <span v-else>Processando...</span>
          </button>
        </label>
      </div>

      <div v-if="loading" class="loading-container">
        <div class="spinner"></div>
        <p>Processando planilha, por favor aguarde...</p>
      </div>

      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal">
          <div class="modal-header">
            <h3>Processamento Concluído</h3>
            <button @click="closeModal" class="close-button">×</button>
          </div>
          <div class="modal-body">
            <p>Total de registros processados: {{ result.totalProcessados }}</p>
            <div class="result-summary">
              <p><span class="success">Sucesso:</span> {{ successCount }}</p>
              <p><span class="warning">Atualizados:</span> {{ updatedCount }}</p>
              <p><span class="error">Erros:</span> {{ errorCount }}</p>
            </div>
            <button @click="downloadLog" class="download-button">Baixar Relatório Completo</button>
          </div>
        </div>
      </div>

      <div class="voltar-container">
        <button class="voltar-button" @click="voltarParaHome">Voltar para Home</button>
      </div>
    </div>

    <div class="chatbot-container" :class="{ 'pulse': showPulse }" @click="toggleChat">
      <img src="https://cdn-icons-png.flaticon.com/512/3670/3670051.png" alt="WhatsApp" class="whatsapp-icon">
    </div>
    
    <div v-if="showChat" class="chatbox">
      <div class="chatbox-header">
        <h3>Suporte</h3>
        <button @click="toggleChat" class="close-button">×</button>
      </div>
      <div class="chatbox-body">
        <textarea v-model="message" placeholder="Digite sua mensagem..." class="message-input"></textarea>
      </div>
      <div class="chatbox-footer">
        <button @click="sendMessage" class="send-button">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClientesMigracao',
  data() {
    return {
      showChat: false,
      showPulse: true,
      message: '',
      file: null,
      fileName: '',
      loading: false,
      showModal: false,
      result: {
        totalProcessados: 0,
        resultados: []
      }
    }
  },
  computed: {
    successCount() {
      return this.result.resultados?.filter(r => r.status === 'CRIADO').length || 0;
    },
    updatedCount() {
      return this.result.resultados?.filter(r => r.status === 'ATUALIZADO').length || 0;
    },
    errorCount() {
      return this.result.resultados?.filter(r => r.status === 'ERRO').length || 0;
    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.file = file;
        this.fileName = file.name;
      }
    },
    async uploadFile() {
      if (!this.file) return;
      
      this.loading = true;
      
      const formData = new FormData();
      formData.append('file', this.file);
      
      try {
        const response = await axios.post('https://api-green.planos.lubconsulta.com.br/api/migrar-clientes', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        this.result = response.data;
        this.showModal = true;
      } catch (error) {
        console.error('Erro ao enviar arquivo:', error);
        alert('Ocorreu um erro ao processar a planilha. Verifique o console para mais detalhes.');
      } finally {
        this.loading = false;
      }
    },
    voltarParaHome() {
      window.location.href = 'https://planos.lubconsulta.com.br';
    },
    toggleChat() {
      this.showChat = !this.showChat;
      if (this.showChat) {
        this.showPulse = false;
      }
    },
    sendMessage() {
      if (this.message.trim()) {
        const phoneNumber = '5585991994652';
        const encodedMessage = encodeURIComponent(this.message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappUrl, '_blank');
        this.message = '';
        this.showChat = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.file = null;
      this.fileName = '';
      document.getElementById('file-upload').value = '';
    },
    downloadLog() {
      const blob = new Blob([JSON.stringify(this.result, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `relatorio-migracao-${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;
}

body {
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 20px;
}

.container {
  width: 800px;
  min-height: 600px;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.clientes-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  padding: 20px;
}

.logo-container {
  margin-bottom: 20px;
}

.logo {
  max-width: 250px;
  height: auto;
}

.title {
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
}

.upload-container {
  margin-bottom: 20px;
}

.file-input {
  display: none;
}

.file-label {
  display: flex;
  flex-direction: column;
  border: 1px solid #F08B1B;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-label:hover {
  border-color: #d97c16;
}

.placeholder {
  margin-bottom: 15px;
  color: #666;
}

.upload-button {
  background-color: #F08B1B;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.upload-button:hover {
  background-color: #d97c16;
}

.loading-container {
  margin-top: 20px;
  text-align: center;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #F08B1B;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-header h3 {
  color: #333;
}

.modal-body {
  margin-bottom: 15px;
}

.result-summary {
  margin: 15px 0;
}

.success {
  color: #25D366;
  font-weight: bold;
}

.warning {
  color: #F08B1B;
  font-weight: bold;
}

.error {
  color: #FF3860;
  font-weight: bold;
}

.download-button {
  background-color: #F08B1B;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 10px;
}

.download-button:hover {
  background-color: #d97c16;
}

.upload-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.file-input:disabled + .file-label {
  opacity: 0.7;
  cursor: not-allowed;
}

.voltar-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.voltar-button {
  background-color: #d3d3d3;
  color: #333;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.voltar-button:hover {
  background-color: #bfbfbf;
}

.chatbot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-icon {
  width: 30px;
  height: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

.chatbox {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 300px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 1000;
}

.chatbox-header {
  background: #25D366;
  color: white;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.chatbox-body {
  padding: 15px;
}

.message-input {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
  margin-bottom: 10px;
}

.chatbox-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  background: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.send-button:hover {
  background-color: #1da851;
}

@media (max-width: 600px) {
  .container {
    padding: 20px;
    margin: 20px;
  }
  
  .chatbox {
    width: calc(100% - 40px);
    right: 20px;
    left: 20px;
  }
}
</style>